import { render, staticRenderFns } from "./CustomContextMenu.vue?vue&type=template&id=03ba6158&scoped=true"
import script from "./CustomContextMenu.vue?vue&type=script&lang=js"
export * from "./CustomContextMenu.vue?vue&type=script&lang=js"
import style0 from "./CustomContextMenu.vue?vue&type=style&index=0&id=03ba6158&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ba6158",
  null
  
)

export default component.exports